import { Link } from 'react-router-dom';

export function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Traditional%20Korean%20scholar%20study%20room%20with%20wooden%20furniture%2C%20calligraphy%20scrolls%20on%20walls%2C%20warm%20amber%20lighting%2C%20serene%20atmosphere%2C%20ancient%20books%2C%20ink%20stone%20and%20brush%2C%20Korean%20cultural%20heritage%20aesthetic%2C%20elegant%20minimalism%2C%20soft%20shadows%2C%20traditional%20hanok%20interior%20style%2C%20scholarly%20ambiance&width=1800&height=900&seq=hero-korean-ethics&orientation=landscape"
        alt="韩国传统学者书房 - 东方文化美学氛围"
        title="韩国伦理 - 东方文化学者书房"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 max-w-4xl mx-auto">
        <p className="text-accent-300 text-xs md:text-sm tracking-[0.2em] uppercase mb-3 md:mb-5 font-medium">
          深度探讨 · 系统解析
        </p>
        <h1 className="text-2xl md:text-5xl font-bold font-heading text-background-50 leading-tight mb-4 md:mb-6">
          韩国伦理：深度解析韩国社会道德与价值观
        </h1>
        <p className="text-background-200/90 text-sm md:text-lg max-w-2xl mx-auto leading-relaxed mb-6 md:mb-8">
          全面探讨韩国伦理的核心内涵，涵盖儒家思想对韩国伦理的深远影响、现代韩国社会的道德观念演变、职场伦理规范及家庭伦理文化
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/ru-jia-lun-li"
            className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            开始探索
          </Link>
          <Link
            to="/about"
            className="px-6 py-2.5 border border-background-300/60 text-background-50 rounded-md text-sm font-medium hover:bg-background-50/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}